import { removeElement } from '../utilities'
import {
  ACTIVE_CLASS,
  prefersReducedMotion,
  saveData,
} from '../utilities/constants'

function isHidden(el) {
  var style = window.getComputedStyle(el)
  return style.display === 'none'
}

export default class {
  constructor(el) {
    try {
      let videoEls = Array.from(el.querySelectorAll('video'))

      if (!videoEls?.length) {
        el.classList.add(ACTIVE_CLASS)

        return
      }

      function replaceVideoWithImage() {
        el.classList.add(ACTIVE_CLASS)

        // Remove video
        videoEls?.forEach((videoEl) => {
          removeElement(videoEl)
        })
      }

      if (saveData || prefersReducedMotion) {
        replaceVideoWithImage()

        return
      }

      function playVideo(videoEl, first = false) {
        try {
          const playPromise = videoEl.play()

          if (first) {
            el.classList.add(ACTIVE_CLASS)
          }

          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                // Great success
                console.log('do we always get here?') // TODO Test, if yes, put active class here
              })
              .catch((error) => {
                console.error(1, error)
                replaceVideoWithImage()
              })
          }
        } catch (err) {
          console.error(2, err)
          replaceVideoWithImage()
        }
      }

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          videoEls.forEach((videoEl) => {
            if (videoEl.paused) {
              videoEl.currentTime = 0

              const videoBreakpoint = videoEl.dataset.breakpoint

              if (videoBreakpoint) {
                const mediaMatch = window.matchMedia(videoBreakpoint)

                if (mediaMatch.matches) {
                  playVideo(videoEl, true)
                }
              } else {
                playVideo(videoEls[0], true)
              }
            }
          })
        }
      })

      videoEls.forEach((videoEl) => {
        const videoBreakpoint = videoEl.dataset.breakpoint

        if (videoBreakpoint) {
          const mediaMatch = window.matchMedia(videoBreakpoint)

          mediaMatch.onchange = (e) => {
            if (e.matches) {
              playVideo(videoEl)
            } else {
              videoEl.pause()
              videoEl.currentTime = 0
            }
          }

          if (mediaMatch.matches) {
            console.log(videoEl)
            playVideo(videoEl, true)
          }
        } else {
          playVideo(videoEls[0], true)
        }
      })
    } catch (err) {
      console.error(err)

      replaceVideoWithImage()
    }
  }
}
